export var SET_CART = 'SET_CART';
export var SET_CART_QTY = 'SET_CART_QTY';
export var SET_CART_SUCCESS = 'SET_CART_SUCCESS';